import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid2,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { CourseInstance } from "../model/entity/CourseInstance";
import { Loading } from "./Loading";
import { Attendance } from "../model/entity/Attendance";
import { useState } from "react";
import { putFetcher } from "./Fetchers";
import handleAxiosError from "./ErrorHandler";
import { notifOk, notifErr } from "./Functions";

interface AttendanceDialogProps {
  open: boolean;
  selectedInstance: CourseInstance;
  handleCancel: any;
}

const AttendanceDialog = (props: AttendanceDialogProps) => {
  const [instance, setInstance] = useState<CourseInstance | null>(
    props.selectedInstance
  );

  const handleChangeAttendance = (attendance: Attendance) => {
    if (!instance) return;

    const updatedArr = instance.attendances.map((a) =>
      a.id === attendance.id
        ? { ...attendance, attended: !attendance.attended }
        : a
    );
    setInstance({ ...instance, attendances: updatedArr });
  };

  const handleSubmit = async () => {
    if (!instance) return;

    try {
      await putFetcher(
        `${process.env.REACT_APP_API_URL}/course-instances/${instance.id}`,
        instance
      );
      notifOk("Změny byly uloženy.");
      props.handleCancel();
    } catch (err) {
      notifErr(handleAxiosError(err));
    }
  };

  if (!instance) return <Loading />;

  return (
    <Dialog open={props.open} onClose={() => props.handleCancel()}>
      <DialogContent dividers>
        <Grid2 container>
          <Grid2 size={{ xs: 12 }}>
            <Typography variant="h5">
              {instance.course.name +
                " " +
                instance.startTime.substring(0, 5) +
                "-" +
                instance.endTime.substring(0, 5)}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12 }}>
            {instance.attendances.length > 0 ? (
              <Table
                size="small"
                sx={{
                  width: "100%",
                  mt: "0.5rem",
                  height: "18.5rem",
                  overflowY: "auto",
                  scrollbarWidth: "thin",
                  display: "block",
                  userSelect: "none",
                }}
              >
                <TableBody>
                  {instance.attendances.map((attendance, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ textAlign: "left", width: "100%" }}>
                        <FormControlLabel
                          control={<Checkbox />}
                          checked={attendance.attended}
                          label={
                            attendance.member.firstName +
                            " " +
                            attendance.member.lastName
                          }
                          value="true"
                          onChange={() => handleChangeAttendance(attendance)}
                        />
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <span>Žádný člen k dispozici</span>
            )}
          </Grid2>
        </Grid2>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "right", gap: 1 }}>
        <Button
          variant="outlined"
          className="cancelBtn"
          onClick={props.handleCancel}
        >
          Zrušit
        </Button>
        <Button variant="outlined" className="submitBtn" onClick={handleSubmit}>
          Uložit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AttendanceDialog;
